import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: '1px solid var(--border-subtle)',
      marginTop: 'auto',
      padding: '1.5rem 1.5rem',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.3rem',
    }}>
      <div style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 800,
        fontSize: '1rem',
        color: 'var(--text-primary)',
        letterSpacing: '-0.01em',
      }}>
        LOTGaming{' '}
        <span style={{ color: 'var(--accent-cyan)' }}>Flux</span>
      </div>
      <div style={{
        fontSize: '0.72rem',
        color: 'var(--text-muted)',
        fontWeight: 500,
      }}>
        {t('footer.tagline', 'The all-in-one panel for CS2 matches and tournaments')}
      </div>
      <div style={{
        fontSize: '0.75rem',
        color: 'var(--text-muted)', /* no extra opacity: it took the line to ~2:1 */
        marginTop: '0.15rem',
      }}>
        {t('footer.madeBy', 'Made By')}{' '}
        <a
          href="https://lotgaming.xyz"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: 'var(--accent-cyan, #22d3ee)',
            textDecoration: 'none',
            transition: 'color 0.15s',
          }}
          onMouseOver={e => e.target.style.color = 'var(--accent-violet, #a78bfa)'}
          onMouseOut={e => e.target.style.color = 'var(--accent-cyan, #22d3ee)'}
        >
          LOTGaming.xyz
        </a>{' '}
        © {year}
      </div>
    </footer>
  );
}

export default Footer;
